import Header from "components/Content/components/Header/Header";
import { useEffect } from "react";
import AboutUs from "./components/AboutUs/AboutUs";
import Contact from "./components/Contact/Contact";
import Service from "./components/Service/Service";
import ScrollReveal from "components/ScrollReveal";
import "./Content.scss";

function Content({ menuSelect, scrollPosition, onSelectMenu, delayAnimation }) {
  useEffect(() => {
    if (!menuSelect || menuSelect === "home") return;
    const menuActiveEl = document.getElementById(menuSelect);
    if (menuActiveEl) menuActiveEl.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [menuSelect]);

  return (
    <div className="content">
      <ScrollReveal>
        <Header idElement="home" scrollPosition={scrollPosition} menuActive={menuSelect} onSelectMenu={onSelectMenu} delayAnimation={delayAnimation} />
      </ScrollReveal>
      <ScrollReveal delay={80}>
        <Service scrollPosition={scrollPosition} idElement="service" />
      </ScrollReveal>
      <ScrollReveal delay={80}>
        <AboutUs idElement="about" scrollPosition={scrollPosition} />
      </ScrollReveal>
      <ScrollReveal delay={80}>
        <Contact idElement="contact" />
      </ScrollReveal>
    </div>
  );
}

export default Content;
